import { useTranslation } from 'react-i18next'
import {
  Information,
  InformationFieldProps
} from '../../../../../../../Information'
import { Offer_functionCodes } from '../../../../../../typings/Offer'

interface Props extends Partial<InformationFieldProps> {
  functionCode: Offer_functionCodes
}

export const ActualCoefficient = ({ functionCode, ...props }: Props) => {
  const { t } = useTranslation('web_ui')

  return (
    <Information.InformationField
      label={t(
        'offers_table_view.function_codes.fields.actual_coefficient.label'
      )}
      smallDivider
      {...props}
    >
      {functionCode.actualCoefficient !== null
        ? `${functionCode.actualCoefficient}`
        : t('no', { ns: 'translation' })}
    </Information.InformationField>
  )
}
